// extracted by mini-css-extract-plugin
export default {"information":"Information_information__PzNtq","content":"Information_content__McBx6","text":"Information_text__NDvn-","image":"Information_image__BFd5-"};